/* eslint-disable import/no-named-as-default-member */
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { participantsByUserId, userByEmail } from 'api/queries'
import { Participant, User } from 'models/API'
import { fetchQuery } from 'utils/ApiUtils'

import { filteredData } from './utils'
dayjs.extend(utc)
dayjs.extend(timezone)
interface Props {
  email: string
  eventId: string
}
const fetchUser = async (email) => {
  let user = null
  let error = null

  try {
    const { items } = (await fetchQuery('userByEmail', userByEmail, {
      email,
      sortDirection: 'DESC',
    })) as unknown as { items: User[] }

    if (items.length > 0) {
      const item = items[0]

      user = item
    } else {
      error = 'Email does not exist'
    }
  } catch (e) {
    console.log(e)

    error = 'Fail to retrieve data'
  }

  return { user, error }
}
const fetchParticipants = async ({ eventId, userId }) => {
  let participants = []

  let nextNextToken = ''

  let hasNext = true

  const usedTokens = []

  const fetchData = async (currentToken) => {
    try {
      const { items, nextToken: newNextToken } = (await fetchQuery(
        'participantsByUserId',
        participantsByUserId,
        {
          userId,
          filter: {
            eventId: {
              eq: eventId,
            },
          },
          ...(currentToken !== null &&
            currentToken.length > 0 && {
              nextToken: currentToken,
            }),
        },
      )) as unknown as { items: Participant[]; nextToken: string | null }

      if (currentToken !== null && currentToken.length > 0)
        usedTokens.push(currentToken)

      return {
        items: filteredData(items, null, false),
        nextToken: newNextToken,
      }
    } catch (e) {
      console.log(e)

      if ('data' in e) {
        const data = e.data
        const newItems = filteredData(
          data['participantsByUserId'].items,
          null,
          false,
        )

        return {
          items: newItems,
          nextToken: data['participantsByUserId'].nextToken,
        }
      }
    }
  }

  while (hasNext === true) {
    const { items, nextToken } = await fetchData(nextNextToken)
    participants = [...participants, ...items]
    nextNextToken = nextToken
    if (nextToken === null) hasNext = false
  }

  return participants
}

const listParticipantsByEventAndEmail = async ({ email, eventId }: Props) => {
  const { user, error: uErr } = await fetchUser(email)
  let participants = []
  if (!uErr) {
    // get participants
    participants = await fetchParticipants({
      eventId,
      userId: user.id,
    })
  }
  return { user, participants }
}

export default listParticipantsByEventAndEmail
